import React, { ReactNode } from 'react';
import { FiClock } from 'react-icons/fi';
import { DateColumnFormatter } from '../../../../helpers/tableHelpers';
import { IParsedContentNotification } from '../../DropdownNotification';

export interface IDefaultNotificationProps extends IParsedContentNotification {
  isOpen?: boolean;
  created_at: string;
  children?: ReactNode;
}

const OpenContainer: React.FC<IDefaultNotificationProps> = ({
  text_pt,
  children,
  created_at,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ...rest
}) => {
  return (
    <>
      <p className="text-[13px] font-[Roboto]">{text_pt}</p>
      {children}
      <div className="flex justify-center items-center mt-[0.7rem] text-xs">
        <FiClock className="inline mr-[3px]" />
        <DateColumnFormatter value={created_at} withHour />
      </div>
    </>
  );
};

const CloseContainer: React.FC<IParsedContentNotification> = ({ text_pt }) => {
  if (text_pt) {
    return (
      <div className="text-[13px] font-[Roboto]">{text_pt.slice(0, 30)}...</div>
    );
  }
  return null;
};

function DefaultNotification({ isOpen, ...rest }: IDefaultNotificationProps) {
  return (
    <div className="flex flex-col flex-1">
      {isOpen ? <OpenContainer {...rest} /> : <CloseContainer {...rest} />}
    </div>
  );
}

export { DefaultNotification };
export default DefaultNotification;
